// Constantes y helpers puros del dominio Valet (estados, etiquetas, secuencial de folio).
//
// PURO (Fase 0 · dominio compartido Web/Native): sin navegador, UI, React, API ni storage.
// Fuente única; re-exportado por components/valet/constants.js para compatibilidad de imports.
//
// Deprecación de 'Recibido' (Jun 2026): el flujo operativo visible tiene 4 estados
// (En_Resguardo → Solicitado → Por Entregar → Entregado). 'Recibido' YA NO forma parte del
// flujo, pero se CONSERVA en LABEL para mostrar defensivamente cualquier registro heredado.
export const ESTADOS = ["En_Resguardo", "Solicitado", "Pagado", "Entregado"];
export const LABEL = { Recibido: "En Resguardo", En_Resguardo: "En Resguardo", Solicitado: "Solicitado", Pagado: "Por Entregar", Entregado: "Entregado" };
// Normaliza el estado de un vehículo a su COLUMNA visible. Un heredado 'Recibido' se muestra
// dentro de 'En_Resguardo' (nunca desaparece). El resto de estados se mapean a sí mismos.
export const colDeEstado = (e) => (e === "Recibido" ? "En_Resguardo" : e);
export const seqDeFolio = (folio) => (folio ? String(folio).split("-").pop() : "");
